<template>
  <div class="user-edit">
    <div class="user-edit--header">
      <span>{{ t.office2_geral_edit_info }}</span>
    </div>
    <div class="user-edit--body">
      <div class="user-edit--body__left">
        <div class="user-preferences--top__content">
          <img :src="this.view.gravatar" class="user-edit--gravatar">
          <a href="http://gravatar.com/" target="_blank" class="btn-outline m-l text-white"><i class="fa fa-edit image__perfil--icon"></i></a>
        </div>
        <div v-if="false" class="user-preferences--center__up-content"></div>
        <div class="user-preferences--center__content">
          <button v-for="button in buttonsPreferences" :key="button.name" :class="button.class" @click="changePrefer(button.action ,button.dataAction)">
            <img :src="`/internacional/public/JTFoxx/img/user-edit/${button.icon}`">
            <span>{{ t[button.t] }}</span>
          </button>
        </div>
      </div>
      <div class="user-edit--body__center">
        <div class="user-info" v-for="(data, i) in inputs['first_screen']" :key="i">
          <div v-if="data.type == 'select'">
            <span>{{ data.label }}</span>
            <select id="select_timezone" name="select_timezone">
              <optgroup v-for="group in data.action" :label="group.label" :key="group.label">
                <option v-for="opt in group.options" :value="opt.value" :selected="opt.value == user.time_zone" :key="opt.value">{{ opt.text }}</option>
              </optgroup>
            </select>
          </div>
          <div v-if="data.type == 'wpp'">
            <span>{{ data.label }}</span>
            <div>

            </div>
          </div>
          <div v-else-if="data.type == 'input'">
            <span>{{ data.label }}</span>
            <input type="text" :value="data.value" :readonly="data.readonly">
          </div>
        </div>
        <div class="save-button"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-edit-index',
  props: {
    view: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      t: this.view.translation,
      handlerRoutes: this.view.handler_routes,
      user: this.view.user,
      countryList: this.view.country_list,
      buttonsPreferences: [
        {name: '2fa', t: 'token_2fa', icon: 'user.svg', class: 'default', action: 'method', dataAction: '2fa'},
        {name: 'invoices', t: 'my_invoices', icon: 'invoices.svg', class: 'default', action: 'route', dataAction: 'route_office_invoices'},
        {name: 'log', t: 'label_log_usuario', icon: 'log.svg', class: 'default', action: 'route', dataAction: 'rota_office_log_usuario'},
        {name: 'password', t: 'change_password_title', icon: 'password.svg', class: 'default', action: 'method', dataAction: 'password'},
        {name: 'delete', t: 'delete_account', icon: 'delete.svg', class: 'delete', action: 'route', dataAction: 'rota_office_autodelete'},
      ],
      inputs: this.view.inputs
    }
  },
  mounted() {
  },
  methods: {
    changePrefer(action, ref) {
      if (action == 'method') {
        this.performAction(ref)
      } else {
        this.openWindow(ref, '_self')
      }
    },
    performAction(action) {
      console.log(action)
    },
    openWindow(url, target) {
      window.open(this.handlerRoutes[url], target)
    }
  }
}
</script>
<style>
.main {
  background-color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
@import '../../../scss/wlStyles/_colors.scss';
.user-edit {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .user-edit--header {
    width: 100%;
    max-width: 1400px;
    margin: 2rem 0;
    span {
      font-family: 'Lato';
      font-size: 2rem;
      color: var(--primary-color);
      font-weight: 500;
    }
  }
  .user-edit--body {
    width: 100%;
    max-width: 1400px;
    display: grid;
    grid-template-columns: minmax(min-content, 30%) minmax(min-content, 70%);
    grid-template-rows: auto;
    align-items: stretch;
    div {
      width: 100%;
    }
    .user-edit--body__left {
      background-color: var(--primary-color);
      border-radius: 0 0 0 12px;
      padding: 2rem 0 2rem 2.438rem;
      box-shadow: 0px 2px 3px $b-shadow1;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      .user-preferences--top__content {
        text-align: center;
        transform: translateX(-2rem);
        .user-edit--gravatar {
          width: 7rem;
          border: 3px solid $dark-blue;
          border-radius: 20px;
        }
        a {
          position: fixed;
          color: $dark-blue !important;
          font-size: 1.5rem;
          bottom: 0;
          margin: .2rem -1.8rem;
        }
      }
      .user-preferences--center__up-content {
        width: 100%;
        background-color: $white;
        border-radius: 8px 0 0 8px;
        padding: 1.25rem 1.85rem;
      }
      .user-preferences--center__content {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
        padding-right: 1.85rem;
        button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: .2rem;
          padding: 1rem .5rem;
          background-color: transparent;
          border: 1px solid $white;
          border-radius: 4px;
          span {
            font-family: 'Muli';
            color: $white;
          }
          img {
            width: 1rem;
            max-height: 17px;
          }
        }
        .delete {
          border: 0 !important;
          background-color: $dark-blue !important;
        }
      }
    }
    .user-edit--body__center {
      background-color: $grey9;
      border-radius: 0 0 12px 0;
      padding: 2.68rem;
      display: inline-flex;
      align-content: space-between;
      flex-wrap: wrap;
      gap: 2%;
      box-shadow: 0px 1px 3px $b-shadow1;
      .user-info {
        width: 49%;
        height: fit-content;
        div {
          flex-direction: column;
          display: flex;
          gap: .5rem;
          span {
            font-family: 'Muli';
            color: var(--primary-color);
          }
          input, select {
            width: 100%;
            min-height: 42px;
            background: $white;
            border: 1px solid $gray3;
            padding: .3rem 0 .3rem .5rem;
            border-radius: 4px;
            color: $black1;
            font-weight: 100 !important;
            margin: 0 !important;
          }
          input:read-only {
            background-color: $gray1 !important;
          }
          select {
            padding: .3rem .5rem !important;
          }
        }
      }
      .save-button {
        border: 1px solid green;
        width: 50%;
        margin-left: 50%;
        height: 3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/user-edit/index.vue